module.exports = __webpack_public_path__ + "img/Zalo.515d75ed.png";